import Api from '@/api/rest/ExchangeResponseApi';

export default new Api();
